export default __webpack_public_path__ + "static/media/hht2_ep10_book_wp_01.7bd828a7.jpg";